import client from 'braintree-web/client';
import paypalCheckout from 'braintree-web/paypal-checkout';
import hostedFields from 'braintree-web/hosted-fields';
import paypal from 'paypal-checkout';

// eslint-disable-next-line
const env = nodeEnv.SANDBOX ? 'sandbox' : 'production';

export default (actions) => {
  const button = document.getElementById('submitCreditCardOrder');
  const {
    openModal,
    processOrder,
    addProducts,
    setPaymentMethod,
    setSelectedUserPaymentId,
    setBraintreeValidity,
    blurBraintreeField,
    setOrderFormMessage
  } = actions;


  client.create({ authorization: process.env.BRAINTREE_TOKENIZATION_KEY }, (err, clientInstance) => {
    if (err) {
      setOrderFormMessage(999);
    }

    hostedFields.create({
      client: clientInstance,
      styles: {
        input: {
          margin: '0 0 8px 0',
          'font-size': '1.2rem',
          'font-family': 'Proxima Nova, Helvetica, Arial',
          color: 'black'
        },
        '.placeholder': {
          color: 'lightgrey'
        },
        '.invalid': {
          color: 'red'
        }
      },
      fields: {
        number: {
          selector: '#card-number',
          placeholder: 'Card Number'
        },
        cvv: {
          selector: '#cvv',
          placeholder: 'CVV'
        },
        expirationDate: {
          selector: '#expiration-date',
          placeholder: 'Exp.'
        }
      }
    }, (hostedFieldsErr, hostedFieldsInstance) => {
      if (hostedFieldsErr) {
        setOrderFormMessage(999);
      }

      if (!hostedFieldsInstance) {
        setOrderFormMessage(999);
      }

      if (hostedFieldsInstance) {
        hostedFieldsInstance.on('focus', () => {
          setPaymentMethod('braintree');
          setSelectedUserPaymentId('0');
        });

        hostedFieldsInstance.on('validityChange', (e) => {
          const { fields, emittedBy } = e;
          const field = emittedBy;
          const thisField = fields[emittedBy];
          const validity = thisField.isValid;
          setBraintreeValidity(field, validity);
        });

        hostedFieldsInstance.on('blur', (e) => {
          const { emittedBy } = e;
          blurBraintreeField(emittedBy);
        });

        button.addEventListener('click', () => {
          openModal('spinner');
          hostedFieldsInstance.tokenize((tokenizeErr, payload) => {
            if (tokenizeErr) {
              setOrderFormMessage(600);
            } else {
              processOrder(payload.nonce)
                .then((resp) => {
                  if (resp) addProducts(resp);
                })
                .catch(() => {
                  setOrderFormMessage(600);
                });
            }
          });
        });
      }
    });

    paypalCheckout.create({ client: clientInstance }, (paypalCheckoutErr, paypalCheckoutInstance) => {
      if (paypalCheckoutErr) {
        console.log('ERROR! paypal');
        setOrderFormMessage(999);
      }

      paypal.Button.render({
        env,
        payment: () => paypalCheckoutInstance.createPayment({
          flow: 'vault'
        }),
        style: {
          size: 'responsive',
          color: 'blue',
          shape: 'pill',
          label: 'buynow'
        },

        onAuthorize: data => paypalCheckoutInstance.tokenizePayment(data)
          .then((payload) => {
            processOrder(payload.nonce)
              .then((resp) => {
                if (resp) addProducts(resp);
              })
              .catch(() => {
                setOrderFormMessage(600);
              });
          }),

        onCancel: () => {
          setOrderFormMessage(700);
        },

        onError: () => {
          setOrderFormMessage(600);
        }
      }, '#paypal-button').then(() => {
      });
    });
  });
};



// WEBPACK FOOTER //
// ./braintree/index.js